// ~/src/plugins/axios.js
import axios from 'axios'
import { useSnackbar } from '@/composables/useSnackbar'

export default function initAxios() {
  axios.defaults.baseURL = import.meta.env.VITE_BACKEND_URL
  axios.defaults.withCredentials = true

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error(error)
      if (error.response?.data?.status === 'UNAUTHORIZED') {
        // show message
        const { openSnackbar } = useSnackbar()
        openSnackbar({
          message: 'Η συνεδρία σας έχει λήξει. Παρακαλώ συνδεθείτε ξανά ',
          color: 'error'
        })
      }
      return Promise.reject(error)
    }
  )
}
